export default class BeschreibungDTO {

  constructor(json) {
    if (json) {
      this.json = json;
      this.nameDe = json.nameDe;
      this.nameFr = json.nameFr;
      this.nameIt = json.nameIt;
      this.nameEn = json.nameEn;
    } else {
      this.json = {}
    }
  }

  get text() {
    const text = this[`name${this.capitalizeFirstLetter(getLanguage())}`];
    if (!text) {
      return this.nameDe;
    }
    return text;
  }

  capitalizeFirstLetter(text) {
    if (!text) {
      return '';
    }
    return text[0].toUpperCase() + text.slice(1);
  }

}
